<template>
  <div>
    <el-dialog
      class="rc-dialog"
      title="批量验证浙政钉绑定情况"
      :visible.sync="dialogInfo.show"
      @close="closeDialog"
      :close-on-click-modal="false"
      destroy-on-close
      width="45%"
    >
      <div class="mb-15">
        以下账号绑定的浙政钉账号姓名与网院账号姓名不一致，请重新绑定。
      </div>
      <ReBindTable :data="listData" />
      <div slot="footer" class="dialog-footer">
        <butn @click="closeDialog" title="取消"></butn>
        <butn
          btntype="primary"
          @click="reBind"
          title="重新绑定"
          v-permission="'user:againBind'"
        ></butn>
      </div>
    </el-dialog>
    <el-dialog
      class="rc-dialog"
      title="浙政钉用户绑定"
      width="1100px"
      :visible.sync="showDingdialogFlag"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      distroy-on-close
      @close="closeShowDingdialog"
    >
      <div class="mb-15">
        除以下用户未绑定成功，其他用户已成功绑定浙政钉账号，错误原因如下：
      </div>
      <FailBindTable :data="failListData" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="closeShowDingdialog"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import butn from "@/components/button/index";
import { againDingUser } from "@/api/user";
import { ReBindTable, FailBindTable } from "./bindTable.js";

export default {
  props: {
    listData: {
      type: Array,
      default() {
        return [];
      },
    },
    dialogInfo: {
      type: Object,
      default() {
        return {
          show: false,
        };
      },
    },
  },
  components: { butn, ReBindTable, FailBindTable },
  data() {
    return {
      showDingdialogFlag: false,
      failListData: [],
    };
  },

  methods: {
    closeShowDingdialog() {
      this.showDingdialogFlag = false;
      this.$emit("close", true);
    },
    closeDialog() {
      this.$emit("close");
    },
    reBind() {
      againDingUser({ userList: this.listData }).then(
        ({ code, data = [], msg = "操作成功" }) => {
          if (code !== 0) return;
          console.log(data);
          if (data.length > 0) {
            this.failListData = data;
            this.showDingdialogFlag = true;
          } else {
            this.$message.success(msg);
            this.$emit("close", true);
          }
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.mb-15 {
  margin-bottom: 15px;
}
</style>
